export const ROUTES = {
  ROOT: '/',
  ABOUT: '/about/',
  WORK: '/work/',
  PROCESS: '/process/',
  SERVICES: '/services/',
  CONTACT: '/contact/',
  PRIVACY: '/privacy/',
  NOT_FOUND: '/404/',
};
